var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('br'),_c('br'),_c('br'),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm",attrs:{"align":"center"}},[_c('span',{staticStyle:{"font-size":"30px"}},[_vm._v(" Access Denied ")]),_c('br')])])])])
}]

export { render, staticRenderFns }